export { default as CircleSolidIcon } from './CircleSolidIcon';
